var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var AdsAdapter = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-Bitmovin8-ads'
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return null
  },

  getTitle: function () {
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return null
  },

  /** Override to return resource URL. */
  getResource: function () {
    return null
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    if (!this.plugin.getAdapter().flags.isJoined) {
      return 'pre'
    }
    return 'mid'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    var events = this.player.exports.PlayerEvent

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)

    // References
    this.references = []
    this.references[events.AdBreakStarted] = this.breakStartListener.bind(this)
    this.references[events.AdBreakFinished] = this.breakEndListener.bind(this)
    this.references[events.AdStarted] = this.adStartListener.bind(this)
    this.references[events.AdFinished] = this.adEndListener.bind(this)
    this.references[events.AdManifestLoaded] = this.manifestListener.bind(this)
    this.references[events.AdQuartile] = this.quartileListener.bind(this)
    this.references[events.AdSkipped] = this.skipListener.bind(this)
    this.references[events.AdClicked] = this.clickListener.bind(this)
    this.references[events.AdError] = this.errorListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()
    // unregister listeners
    if (this.player && this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  },

  breakStartListener: function () {
    this.fireBreakStart()
  },

  breakEndListener: function () {
    this.fireBreakStop()
  },

  adStartListener: function () {
    this.fireStart()
    this.fireJoin()
    this.counter = 0
  },

  adEndListener: function () {
    this.fireStop()
  },

  manifestListener: function () {

  },

  quartileListener: function () {
    this.counter++
    this.fireQuartile(this.counter)
  },

  skipListener: function () {
    this.fireSkip()
  },

  clickListener: function () {
    this.fireClick()
  },

  errorListener: function () {
    this.fireError()
  }
})

module.exports = AdsAdapter
